import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";

// Reusable festival countdown. Counts down to `startISO`; once the festival has
// begun it switches to "Ongoing · ends in…" counting to `endISO`; after that it
// renders nothing. Drop it into any festival promo — pass IST-anchored ISO dates.
export default function FestivalCountdown({ startISO, endISO, testid = "festival-countdown" }) {
  const { pick } = useLang();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const start = new Date(startISO).getTime();
  const end = endISO ? new Date(endISO).getTime() : start;

  let mode, target;
  if (now < start) { mode = "upcoming"; target = start; }
  else if (now < end) { mode = "ongoing"; target = end; }
  else return null;

  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const mins = Math.floor((diff % 3600000) / 60000);
  const secs = Math.floor((diff % 60000) / 1000);

  const units = [
    { v: days, label: pick("दिन", "Days") },
    { v: hours, label: pick("घंटे", "Hrs") },
    { v: mins, label: pick("मिनट", "Min") },
    { v: secs, label: pick("सेकंड", "Sec") },
  ];

  const heading = mode === "upcoming"
    ? pick("आरम्भ में", "Begins in")
    : pick("चल रहा है · समापन में", "Ongoing · ends in");

  return (
    <div className="mt-5" data-testid={testid} data-mode={mode}>
      <p className="overline-label text-saffron">{heading}</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {units.map((u) => (
          <div
            key={u.label}
            className="flex min-w-[3.25rem] flex-col items-center border border-[var(--gold)]/45 bg-[var(--parchment)] px-2.5 py-1.5 shadow-[0_2px_10px_rgba(199,80,0,0.08)]"
          >
            <span className="dh-num text-2xl font-semibold leading-none text-ink tabular-nums">
              {String(u.v).padStart(2, "0")}
            </span>
            <span className="mt-1 text-[9px] uppercase tracking-[0.12em] text-ink-3">{u.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
